export const setIsOnline = isOnline => {
	return { type: 'SET_IS_ONLINE', isOnline };
};